import * as React from "react";
import { SVGProps } from "react";

const UpgradeRejected: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="120"
    height="121"
    viewBox="0 0 120 121"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect y="0.292969" width="120" height="120" rx="60" fill="white" />
    <rect
      y="0.292969"
      width="120"
      height="120"
      rx="60"
      fill="#F3B8B3"
      fillOpacity="0.25"
    />
    <path
      d="M67.048 52.7445C66.3571 52.0537 65.2152 52.0537 64.5244 52.7445L59.4995 57.7694L54.4746 52.7445C53.7837 52.0537 52.6418 52.0537 51.951 52.7445C51.2601 53.4354 51.2601 54.5773 51.951 55.2681L56.9759 60.293L51.951 65.3179C51.2601 66.0088 51.2601 67.1507 51.951 67.8415C52.3078 68.1983 52.7607 68.3652 53.2128 68.3652C53.6616 68.3652 54.1389 68.2003 54.476 67.8401L59.4995 62.8166L64.5244 67.8415C64.8812 68.1983 65.3342 68.3652 65.7862 68.3652C66.2382 68.3652 66.6912 68.1983 67.048 67.8415C67.7388 67.1507 67.7388 66.0088 67.048 65.3179L62.0231 60.293L67.048 55.2681C67.7388 54.5773 67.7388 53.4354 67.048 52.7445Z"
      fill="#DA291C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M59.5 36.293C46.2609 36.293 35.5 47.0538 35.5 60.293C35.5 73.5321 46.2609 84.293 59.5 84.293C72.7391 84.293 83.5 73.5321 83.5 60.293C83.5 47.0538 72.7391 36.293 59.5 36.293ZM39.071 60.293C39.071 49.0295 48.2365 39.864 59.5 39.864C70.7635 39.864 79.929 49.0295 79.929 60.293C79.929 71.5564 70.7635 80.722 59.5 80.722C48.2365 80.722 39.071 71.5564 39.071 60.293Z"
      fill="#DA291C"
    />
  </svg>
);

export default UpgradeRejected;
